import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "commonModule/services/common"

export interface GetFilterParametersResponse extends AxiosResponse {
  data: {
    featureCategory: string
    id: number
    keyName: string
  }[]
}
// NEW
const defaultFiltersurl = `/property/features/filters`
export function getAllFiltersApi(
  axiosInstance: AxiosInstance,
): Promise<GetFilterParametersResponse> {
  return axiosInstance({
    method: "get",
    url: defaultFiltersurl,
  }) as Promise<GetFilterParametersResponse>
}

// ---------------------------------------------------------------

interface SendLinkOnNumberrequest {
  code: string
  mobileNumber: string
}

export interface SendOnLinkRequest extends Partial<AxiosRequestConfig> {
  params: SendLinkOnNumberrequest
}

export interface SendOnLinkResponse extends AxiosResponse {
  data: ResponseData
}

export function sendLinkOnNumberApi(
  { params, ...config }: SendOnLinkRequest,
  axiosInstance: AxiosInstance,
): Promise<SendOnLinkResponse> {
  return axiosInstance({
    method: "get",
    url: `/user/send-app-link/${params.code}/${params.mobileNumber}`,
    ...config,
  }) as Promise<SendOnLinkResponse>
}
